import { createContext, useContext, useEffect, useCallback, useMemo } from "react";

const dict = {
  fr: {
    // header
    nav_formations: "Formations",
    nav_offers: "Notre offre",
    nav_resources: "Ressources",
    nav_about: "À propos",
    nav_blog: "Blog - Regards d'experts",
    nav_guides: "Guides gratuits",
    nav_login: "Se connecter",
    nav_register: "Créer un compte",
    nav_dashboard: "Mon espace",
    nav_logout: "Déconnexion",
    // hero
    hero_badge: "Neurosciences × Petite enfance",
    hero_title_1: "Développement de la",
    hero_title_accent: "petite enfance",
    hero_title_2: ": des formations professionnelles pour renforcer les compétences des acteurs de terrain, garantir un accompagnement et des soins de qualité.",
    hero_sub: "Permettre à l'adulte de comprendre le développement cérébral des tout-petits pour garantir l'équité et l'inclusion. Parce que chaque enfant mérite de grandir, d'apprendre et de s'épanouir dans les meilleures conditions dès le départ.",
    hero_cta_b2c: "Rejoindre une formation",
    hero_cta_b2b: "Découvrir notre offre",
    hero_badge_cpf: "Attestation de participation",
    hero_badge_pros: "+1 200 professionnels formés",
    // benefits
    why_eyebrow: "Pourquoi Beehive ?",
    why_title: "Chaque enfant a le droit de grandir, d'apprendre et de s'épanouir.",
    why_sub: "Pour faire de ce droit une réalité, nos programmes sont conçus par des experts de la petite enfance. Ils transmettent le savoir de manière simple, afin de donner à l'adulte les outils nécessaires pour entourer l'enfant de soin bienveillant au quotidien.",
    why_1_t: "Comprendre le cerveau",
    why_1_b: "Les mécanismes clés du développement 0-6 ans, sans jargon inutile, avec des schémas visuels.",
    why_2_t: "Appliquer au quotidien",
    why_2_b: "Des gestes concrets, des postures testées sur le terrain, à mettre en pratique dès le lendemain.",
    why_3_t: "Certifier vos acquis",
    why_3_b: "Une attestation de participation vous est remise en fin de session.",
    // catalog
    catalog_eyebrow: "Catalogue",
    catalog_title: "Formations conçues pour les professionnels de la petite enfance.",
    catalog_see_all: "Voir toutes les formations",
    // lead magnet
    lm_eyebrow: "Ressource offerte",
    lm_title: "Le guide Harvard pour transformer vos journées.",
    lm_sub: "Un guide PDF inspiré des ressources du Center on the Developing Child (Harvard University), traduit et adapté à la pratique française.",
    lm_bullet_1: "12 pages illustrées, à imprimer et afficher",
    lm_bullet_2: "Basé sur les recherches du Center on the Developing Child (Harvard)",
    lm_bullet_3: "Utilisable dès demain avec vos enfants",
    // testimonials
    testi_eyebrow: "Ils en parlent",
    testi_title: "Des retours qui parlent d'eux-mêmes.",
    // final cta
    cta_final_title: "Prête à changer votre posture professionnelle ?",
    cta_final_sub: "Rejoignez la formation qui donne enfin du sens à ce que vous faites au quotidien avec les enfants.",
    cta_final_1: "Créer mon compte gratuit",
    cta_final_2: "Explorer les formations",
    // about home
    about_eyebrow: "La méthode Beehive",
    about_title: "Donner à chaque enfant le droit de grandir en toute sécurité, d'apprendre avec plaisir et de s'épanouir avec bienveillance.",
    about_sub: "Nous croyons qu'un professionnel qui comprend le cerveau d'un enfant devient plus juste, plus calme, plus fier. C'est ainsi que se construit un accueil de qualité — pour les enfants, pour les familles, pour les équipes.",
    about_stat_1: "d'expérience terrain",
    about_stat_2: "professionnels formés",
    about_stat_3: "satisfaction",
  },
};

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  useEffect(() => { document.documentElement.lang = "fr"; }, []);
  const t = useCallback((k) => dict.fr[k] ?? k, []);
  const value = useMemo(() => ({ lang: "fr", t }), [t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
